import { useEffect, useState } from 'react'

/**
 * Een waarde die pas meeverandert als hij `delay` milliseconden stilstaat.
 *
 * Nodig naast useDebouncedWrite, dat wachten koppelt aan wegschrijven: hier
 * hoeft niets weg, alleen een zware herberekening (zoeken door duizenden
 * adressen) mag niet bij elke aanslag lopen.
 *
 * @template T
 * @param {T} value - De actuele waarde, bijvoorbeeld wat er in een zoekveld staat
 * @param {number} delay - Wachttijd in milliseconden
 * @returns {T} De waarde van na de laatste pauze
 */
const useDebouncedValue = (value, delay) => {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay)
        return () => clearTimeout(timer)
    }, [value, delay])

    return debounced
}

export default useDebouncedValue
